// extracted by mini-css-extract-plugin
export var arrow = "_en-1";
export var content = "_en-0";
export var highlighted = "_en-2";